import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IBatch } from 'src/app/models/batches/batch';
import { BatchesService } from 'src/app/services/batches.services';

@Component({
  selector: 'app-favourite-batch-action',
  templateUrl: './favourite-batch-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FavouriteBatchActionComponent {
  @Input() batch!: IBatch;
  @Input() isFavourite: boolean = false;
  @Output() actionComplete = new EventEmitter<void>();

  constructor(
    private batchesService: BatchesService,
    private snackBar: MatSnackBar,
  ) {}

  onToggleFavourite(): void {
    if (!this.batch.id) return;

    this.batchesService.favoriteBatch(this.batch).subscribe({
      next: () => {
        const msg = this.isFavourite ? 'Removed from Favourites' : 'Added to Favourites';
        this.snackBar.open(msg, 'close', { duration: 2000 });
        this.actionComplete.emit();
      },
      error: () => {
        this.snackBar.open('Action failed', 'close', { duration: 2000 });
      },
    });
  }
}
